import OriginAnchor from './anchor';
import AnchorLink from './anchor-link';
var Anchor = OriginAnchor;
Anchor.Link = AnchorLink;
export default Anchor;